module.exports = __webpack_public_path__ + "img/selected6-min.b4513d3c.png";